import { Button, Center } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { Loader } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase/client";
import { useAuth } from "../context/AuthContext";

interface PackageProps {
  title: string;
  url?: string;
  product?: string;
  theme?: string;
}

export default function PurchaseButton({ theme, title = 'Get Started', url, product }: PackageProps) {
  const { user } = useAuth();

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  let cssClasses = `block w-full py-3 rounded-lg bg-indigo-100 text-indigo-600 font-medium text-center hover:bg-indigo-200 transition-colors`;
  if (theme === 'pop') {
    cssClasses = `block w-full py-3 rounded-lg bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-medium text-center hover:opacity-90 transition-opacity`;
  }

  return (
      loading ? <Center><Loader type="dots" color="blue" /></Center> :
      <a  
        className={cssClasses}
        onClick={async () => {
          if (url) {
            if (url.startsWith('/')) {
              navigate(url);
              return;
            } else {
              window.location.assign(url);
            }
          }
  
          if (!user || !user.id) {
            navigate('/register');
            return;
          }
  
          setLoading(true);
  
          try {
            if (product) {
              const { data, error } = await supabase.functions.invoke('stripe-checkout', {
                body: JSON.stringify({ product_id: product })
              });
  
              if (error) {
                showNotification({
                  message: error,
                })
              }
  
              if (data && data.url) {
                window.location.assign(data.url);
              }
            }
          } catch (e) {
            showNotification({
              message: JSON.stringify(e),
            });
          } finally {
            setLoading(false);
          }
        }}
      >{title}</a>
  );
}
